import { DateTime, DateTimeFormatOptions, LocaleOptions } from "luxon";
import React from "react";

import styles from "./Date.module.css";
import PropertyWithTitle from "./PropertyWithTitle";

interface DateProps {
  customDateFormat?: string;
  isHighlighted?: boolean;
  isInline?: boolean;
  title?: string;
  value: string;
}

const defaultDateFormat: LocaleOptions & DateTimeFormatOptions = {
  weekday: "short",
  day: "2-digit",
  month: "short",
  hour: "2-digit",
  minute: "2-digit",
};

const noTimeDateFormat: LocaleOptions & DateTimeFormatOptions = {
  weekday: "short",
  day: "2-digit",
  month: "short",
  year: "numeric",
};

export function DateWithTitle(props: DateProps) {
  if (!props.value) {
    return null;
  }
  return (
    <PropertyWithTitle title={props.title || "shared.date"}>
      <CustomDate {...props} />
    </PropertyWithTitle>
  );
}

export default function CustomDate({
  customDateFormat,
  isHighlighted,
  isInline,
  value,
}: DateProps) {
  const luxon = DateTime.fromISO(value, { setZone: true });

  const TagName = isInline ? "span" : "div";

  const dateFormat =
    customDateFormat === "no-time" ? noTimeDateFormat : defaultDateFormat;

  return (
    <TagName className={isHighlighted ? styles.isHighlighted : ""}>
      {luxon.toLocaleString(dateFormat)}
    </TagName>
  );
}
